module.exports = __webpack_public_path__ + "static/media/m-blog-3.53194b0e.jpg";